export const getLocations = pageId =>
  fetch(
    `${
      process.env.REACT_APP_API_URL
    }/CastingLocationCs?filter[where][showPageRExternalIdC]=${pageId}`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  ).then(response => response.json());



// WEBPACK FOOTER //
// ./src/api/locationAPI.js